// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"386":"46b5df94","472":"9ef3c5a4","501":"a6f6002e","538":"8ffcb279","764":"c5d2cb7f"}[chunkId] + ".chunk.js";
};